export const BUILTIN_TEMPLATES = {
  vehicle: {
    id: 'builtin_vehicle',
    name: 'Vehicle Pre-Start',
    type: 'vehicle',
    sections: [
      {
        title: 'TYRES & BODY',
        items: [
          'Tyres – condition & pressure',
          'Spare tyre inflated & serviceable',
          'No visible damage / fluid leaks',
        ],
      },
      {
        title: 'LIGHTS & VISION',
        items: [
          'All lights working and clean',
          'Windscreen/windows clean & intact',
          'Wipers working / Mirrors clean',
        ],
      },
      {
        title: 'CONTROLS',
        items: [
          'Brakes firm & responsive',
          'Horn operational',
          'Seatbelts working correctly',
        ],
      },
      {
        title: 'FLUIDS',
        items: [
          'Oil level OK',
          'Coolant OK',
          'Brake fluid & power steering OK',
          'Battery OK',
        ],
      },
      {
        title: 'CABIN',
        items: [
          'Cab clean – no loose items (projectile risk)',
          'Floor & pedals clear',
          'Windows CLOSED / Vents recirculate',
        ],
      },
      {
        title: 'EXTERNAL & FIRE',
        items: [
          'External clean – lights & plates visible',
          'No grass/debris under vehicle',
          'Fire extinguisher present & in service',
        ],
      },
      {
        title: 'EQUIPMENT',
        items: [
          'First aid kit present full & in date',
          'Recovery gear clean & serviceable',
          'Load secured – no movement',
        ],
      },
      {
        title: 'COMMS & FUEL',
        items: [
          'Fuel sufficient – trip + contingency',
          'UHF on correct channel Tx/Rx confirmed',
          'Comms backup available (sat phone)',
        ],
      },
      {
        title: 'FINAL',
        items: [
          'Weather / road conditions assessed',
          'Area clear – safe to proceed',
        ],
      },
    ],
  },

  pre_drill: {
    id: 'builtin_pre_drill',
    name: 'Pre-Drill Checklist',
    type: 'pre_drill',
    sections: [
      {
        title: 'APPROVALS AND PLANNING',
        items: [
          'Programme of Work approved and current',
          'Permits and programme approvals current',
          'Heritage clearance confirmed for all planned collar locations',
          'Access approvals obtained from landholders / pastoral lessees',
          'Collar locations pegged and GPS coordinates verified',
          'Old workings identified and marked on field maps and GPS',
        ],
      },
      {
        title: 'RISK AND DOCUMENTATION',
        items: [
          'JHA / JSA completed and signed for this program',
          'Relevant SWPs reviewed by all personnel',
          'Critical risks discussed at pre-program briefing',
          'TARPs reviewed and understood by all personnel',
          'LM1 ERP reviewed and current',
          'Asbestiform mineral risk assessed for target lithologies',
        ],
      },
      {
        title: 'PERSONNEL AND COMPETENCY',
        items: [
          'All personnel hold current site induction',
          'All personnel hold current first aid certificate (minimum 1 per field team)',
          'Drill crew competency verified',
          'Offsiders briefed on exclusion zones and rod handling',
          'All personnel declared fit for work',
          'Rig-specific induction completed for all personnel attending drill site',
        ],
      },
      {
        title: 'COMMUNICATIONS',
        items: [
          'Communication plan documented',
          'Emergency contacts available and current',
          'Scheduled call schedule confirmed with coordinator',
          'Satellite phone charged and tested',
          'Starlink Mini operational (if equipped)',
          'UHF channels confirmed with drill contractor',
        ],
      },
      {
        title: 'SITE SETUP',
        items: [
          'Drill pad is safe level and stable – no signs of ground instability',
          'Access and egress to drill pad is clear for all vehicles',
          'Exclusion zones established and signed',
          'Site signage in place (hearing protection PPE exclusion zones)',
          'Sumps adequate for anticipated cuttings volume',
          'Sample layout area designated upwind of cyclone',
        ],
      },
      {
        title: 'ENVIRONMENTAL AND FIRE',
        items: [
          'Clearing minimised to approved pad footprint',
          'No heritage disturbance – clearance confirmed',
          'Spill kit available and accessible',
          'Fire risk assessed – DFES fire danger rating checked',
          'Fire extinguishers on site and in-date',
          'Fuel storage safe and compliant',
          'Refuelling procedures understood by all personnel',
          'Weed hygiene completed on all vehicles before entering tenement',
        ],
      },
      {
        title: 'DRILL RIG AND EQUIPMENT',
        items: [
          'Rig fit for purpose – no unresolved safety defects',
          'Guards in place on all rotating components',
          'Emergency stops tested and locations known',
          'Whip checks fitted to all high-pressure hose connections',
          'All hoses in good condition – no damage or wear',
          'Hydraulics intact – no leaks',
          'LOTO isolation procedure understood',
          'Rod handling systems functional',
          'Compressor pre-start completed',
          'Emergency access to rig clear',
        ],
      },
      {
        title: 'CONTRACTOR WORK PRACTICES',
        items: [
          'Offsiders working safely – no unsafe manual handling observed',
          'Correct PPE in use by all drill crew',
          'No shortcuts observed – procedures being followed',
          'Driller in control and communicating clearly',
          'Communication acknowledged – driller aware of geologist / personnel',
        ],
      },
    ],
  },

  drill_rig: {
    id: 'builtin_drill_rig',
    name: 'Drill Rig Safety Checklist',
    type: 'drill_rig',
    sections: [
      {
        title: 'EXCLUSION ZONES',
        items: [
          'Exclusion zones established and marked',
          'Safe distances from rig components maintained',
          'No unauthorised persons within zones',
        ],
      },
      {
        title: 'ROTATING EQUIPMENT',
        items: [
          'No personnel approaching while rods are turning',
          'Guards in place on all rotating components',
          'Loose clothing jewellery and hair secured',
        ],
      },
      {
        title: 'ROD HANDLING AND PINCH POINTS',
        items: [
          'Offsider using correct rod handling technique',
          'No personnel in pinch point zones during rod changes',
          'No standing under suspended loads',
          'Stand-down position used during rod changes',
        ],
      },
      {
        title: 'COMMUNICATION',
        items: [
          'Driller is aware of all personnel on pad',
          'Positive acknowledgement confirmed before approaching rig',
          'Clear communication signals in use',
          'Emergency stop locations known to all',
        ],
      },
      {
        title: 'PRESSURE HAZARDS',
        items: [
          'Whip checks fitted to all high-pressure hose connections',
          'All hoses in good condition – no visible damage or wear',
          'No active leaks from air lines hydraulics or water lines',
        ],
      },
      {
        title: 'SAMPLING SAFETY',
        items: [
          'Dust controlled – ute positioned upwind of cyclone',
          'P2 respiratory protection in use by sample personnel',
          'Sample area is tidy and clear of trip hazards',
          'Exclusion zone around cyclone maintained during sampling',
        ],
      },
      {
        title: 'GROUND AND SITE CONDITIONS',
        items: [
          'Drill pad is stable and level',
          'No trip hazards in working areas',
          'Access and egress clear of obstructions',
          'Sump is adequate and not overflowing',
        ],
      },
      {
        title: 'FIRE',
        items: [
          'Fire extinguisher accessible and in-date',
          'No ignition sources near fuel storage or refuelling area',
          'Fuel storage compliant (containers bunding labelling)',
        ],
      },
      {
        title: 'EMERGENCY READINESS',
        items: [
          'Emergency stop locations known to all personnel on pad',
          'First aid kit accessible and stocked',
          'Satellite phone charged and accessible',
          'Emergency contacts known',
        ],
      },
      {
        title: 'BEHAVIOUR AND PPE',
        items: [
          'All personnel wearing correct PPE (hard hat hi-vis boots glasses HPD P2)',
          'Procedures are being followed – no observed shortcuts',
          'Stop work authority understood – personnel will call STOP THE RIG if unsafe',
        ],
      },
    ],
  },
};

export const BUILTIN_TYPE_META = {
  vehicle: { label: 'Vehicle Pre-Start', icon: '🚗', description: 'Ute, truck or light vehicle' },
  pre_drill: { label: 'Pre-Drill Checklist', icon: '📋', description: 'Before drilling commences' },
  drill_rig: { label: 'Drill Rig Safety', icon: '⚙️', description: 'Rotary or RC drill rig' },
};

export function getBuiltinTemplate(type) {
  return BUILTIN_TEMPLATES[type] ?? null;
}

export function formatType(type) {
  return BUILTIN_TYPE_META[type]?.label ?? type;
}
